import { render, staticRenderFns } from "./downloadpackingslib.vue?vue&type=template&id=267d25bc&"
import script from "./downloadpackingslib.vue?vue&type=script&lang=js&"
export * from "./downloadpackingslib.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports